<template>
  <div>
    <div class="main-layout__list main-layout__list_mxh80">
      <div
        class="main-layout__item main-layout__item_hover main-layout__item_head main-layout__item_p12"
      >
        <div class="w-3 t-c foz-23">
          <p>#</p>
        </div>

        <div class="w-10">
          <span>{{$t('listsHeader.toolName')}}</span>
        </div>

        <div class="w-10">
          <p>{{$t('listsHeader.canUseScooter')}}</p>
        </div>

        <div class="main-layout__item-actions">
          <p>{{$t('listsHeader.actions')}}</p>
        </div>
      </div>

      <div
        class="main-layout__item main-layout__item_hover main-layout__item_mh"
        v-for="(item, index) in list"
        :key="item.id"
        :class="{
          delete: item.deletion_tag,
        }"
      >
        <div class="w-3 t-c">
          <p>{{ index + 1 }}</p>
        </div>

        <div class="w-10">
          <span>{{ item.name }}</span>
        </div>

        <div class="w-10">
          <p>{{ item.is_scooter ? "+" : "-" }}</p>
        </div>

        <div class="main-layout__item-actions">
          <div>
            <svg
              v-if="$guard('write', 'Tags')"
              @click="editTool(item)"
              width="24px"
              height="24px"
              class="main-layout__item-icon"
            >
              <use xlink:href="/images/svg/symbols.svg#svg-user-message" />
            </svg>
          </div>
          <div>
            <svg
              @click="openDeleteModal(item.id)"
              width="24px"
              height="24px"
              class="main-layout__item-icon"
            >
              <use xlink:href="/images/svg/symbols.svg#svg-user-del" />
            </svg>
          </div>

          <div>
            <delete-request
              v-if="$guard('delete', 'Tags') && item.deletion_tag"
              :item="item"
              :type="'instruments'"
              @save="fetch"
              @remove="openDeleteModal"
            />
          </div>
        </div>
      </div>
    </div>

    <add-btn v-if="$guard('write', 'Tags')" @onClick="openModalAdapter" />

    <modal :show="isShow" :dark="true" :outside="false" @close="closeModal">
      <tools-modal :isUpdate="updatedId" @close="closeModal" @done="saveTool" />
    </modal>

    <modal
      :show="isShowDeleteModal"
      :showBtn="false"
      :dark="true"
      :outside="false"
      @close="closeDeleteModal"
    >
      <delete-modal
        :title="$t('global.areUsure').toString()"
        @cancel="closeDeleteModal"
        @next="deleteConfirm"
      />
    </modal>
  </div>
</template>

<script>
import addBtn from '@/components/controls/addBtn'
import toolsModal from '@/components/modals/tools/toolsModal'
import deleteRequest from '@/components/controls/deleteRequest'

import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
    components: { addBtn, toolsModal, deleteRequest },
    data() {
        return {
            isShow: false,
            isShowDeleteModal: false,
            isAdding: true,
            updatedId: null,
            deletedId: null,
        }
    },

    computed: {
        ...mapGetters({
            list: 'tools/list',
        }),
    },
    methods: {
        ...mapActions({
            fetch: 'tools/fetch',
            add: 'tools/add',
            update: 'tools/update',
            remove: 'tools/remove',
            requestForDelete: 'deleteControl/requestForDelete',
        }),
        ...mapMutations({
            setState: 'tools/setState',
        }),
        openModalAdapter() {
            this.isAdding = true
            this.openModal()
        },
        openModal() {
            this.isShow = true
        },
        closeModal() {
            this.isShow = false
            this.updatedId = null
        },
        closeDeleteModal() {
            this.isShowDeleteModal = false
        },
        openDeleteModal(id) {
            this.deletedId = id
            this.isShowDeleteModal = true
        },
        async deleteConfirm() {
            try {
                if (!this.$guard('delete', 'Tags')) {
                    await this.requestForDelete({
                        id: this.deletedId,
                        type: 'instruments',
                    })
                    await this.fetch()

                    this.closeDeleteModal()
                    return
                }

                const response = await this.remove(this.deletedId)
                const isOkey = response.status === 200

                if (!isOkey) return
                await this.fetch()
                this.closeDeleteModal()
            } catch (err) {
                // log err
            }
        },
        editTool(item) {
            this.isAdding = false
            console.log(item)
            this.setState({
                key: 'tool',
                data: {
                    name: item.name,
                    is_scooter: item.is_scooter,
                },
            })
            this.updatedId = item.id
            this.openModal()
        },
        async saveTool() {
            if (this.isAdding) {
                const response = await this.add()
                const isOkey = response.status === 201

                if (!isOkey) return
                await this.fetch()
                this.closeModal()
            } else {
                const response = await this.update(this.updatedId)
                const isOkey = response.status === 200

                if (!isOkey) return
                await this.fetch()
                this.closeModal()
            }
        },
    },
}
</script>
